import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button } from 'reactstrap';
// import AddressItem from './addressItem';
import TheLayout from '../../layout/TheLayout';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];

const Mypage = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const customer = useSelector((state) => state.auth.customer, shallowEqual);
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>登録情報｜株式会社TERRA</title>
      </Helmet>
      <div className="mypage" style={{ background: 'rgb(235, 244, 246)' }}>
        <div className="d-none d-lg-block">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb bg-transparent" style={{ color: 'rgb(181,189,185)', background: 'rgb(235, 244, 246)!important' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>登録情報</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-2 p-md-5">
          <div
            className="information bg-white px-3 px-lg-5"
            style={{
              borderRadius: '1rem',
            }}
          >
            <h4 className="row border-bottom py-2 pl-2" style={{ color: 'rgb(71,108,138)' }}>会員登録情報</h4>
            <div className="row border-bottom py-2">
              <div className="col-3 col-md-3">
                基本情報
              </div>
              <div className="col-6 col-md-7">
                {customer.name}
                <br />
                {`〒${customer?.zip_code || ''}`}
                <br />
                {customer?.prefecture || ''}
                県
                {customer?.address_first || ''}
                市
                {customer?.address_second || ''}
                {customer?.address_second || ''}
                <br />
                {customer?.phone_number || ''}
              </div>
              <div className="col-3 col-md-2 pr-2">
                <Button
                  style={{
                    background: 'transparent',
                    border: 'solid 1px rgb(71,108,138)',
                    color: 'rgb(71,108,138)',
                    height: '2rem',
                    lineHeight: '2rem',
                    borderRadius: '1rem',
                    padding: '0 20px',
                    float: 'right',
                  }}
                  onClick={() => history.push('/mypage/profile/edit')}
                >
                  変更
                </Button>
              </div>
            </div>
            <div className="row border-bottom py-2">
              <div className="col-3 col-md-3">
                メールアドレス
              </div>
              <div className="col-6 col-md-7">
                {customer.email}
              </div>
              <div className="col-3 col-md-2 pr-2">
                <Button
                  style={{
                    background: 'transparent',
                    border: 'solid 1px rgb(71,108,138)',
                    color: 'rgb(71,108,138)',
                    height: '2rem',
                    lineHeight: '2rem',
                    borderRadius: '1rem',
                    padding: '0 20px',
                    float: 'right',
                  }}
                  onClick={() => history.push('/mypage/profile/edit')}
                >
                  変更
                </Button>
              </div>
            </div>
            <div className="row py-2">
              <div className="col-3 col-md-3">
                パスワード
              </div>
              <div className="col-6 col-md-7">
                ＊＊＊＊＊＊＊＊
              </div>
              <div className="col-3 col-md-2 pr-2">
                <Button
                  style={{
                    background: 'transparent',
                    border: 'solid 1px rgb(71,108,138)',
                    color: 'rgb(71,108,138)',
                    height: '2rem',
                    lineHeight: '2rem',
                    borderRadius: '1rem',
                    padding: '0 20px',
                    float: 'right',
                  }}
                  onClick={() => history.push('/mypage/update_password')}
                >
                  変更
                </Button>
              </div>
            </div>
          </div>
          {/* <div
            className="addresses bg-white px-3 px-lg-5 my-5"
            style={{
              borderRadius: '1rem',
            }}
          >
            <h4 className="row border-bottom py-2 pl-2" style={{ color: 'rgb(71,108,138)' }}>
            お届け先の変更・追加
            </h4>
            {customer.addresses && customer.addresses.length > 0 ? (
              customer.addresses.map((address, i) => (
                <AddressItem key={address.id} address={address} i={i + 1} />
              ))
            ) : (
              <div className="row border-bottom py-2">
                <div className="col-3 col-md-3">
                  追加お届け先1
                </div>
                <div className="col-6 col-md-7">
                  {customer.name}
                  <br />
                  {`〒${customer?.zip_code || ''}`}
                  <br />
                  {customer?.prefecture || ''}
                  県
                  {customer?.address_first || ''}
                  市
                  {customer?.address_second || ''}
                  {customer?.address_third || ''}
                  <br />
                  {customer?.phone_number || ''}
                </div>
              </div>
            )}
            <div className="row border-bottom py-3">
              <Button
                style={{
                  background: 'transparent',
                  border: 'solid 1px rgb(71,108,138)',
                  color: 'rgb(71,108,138)',
                  height: '2rem',
                  lineHeight: '2rem',
                  borderRadius: '1rem',
                  padding: '0 20px',
                  float: 'right',
                  maxWidth: '300px',
                  margin: 'auto',
                }}
                onClick={() => history.push('/mypage/address/add')}
              >
                お届け先を追加
              </Button>
            </div>
          </div> */}
        </div>
      </div>
    </TheLayout>
  );
};

export default Mypage;
